import { defineDirective, IUibModalScope } from "../omnia";
import { IAnalysisValueColumn } from "../types";
import { IColumnDescription } from "./columns";

export class ColumnsPopupCtrl {

    static create(): ng.IDirective {

        return defineDirective(ColumnsPopupCtrl, "app/soil/table/columnsPopup.html", {});

    }

    static $inject = ["$scope"];

    private $scope: IUibModalScope;

    private columns: IColumnDescription[];
    private analysisColumns: IAnalysisValueColumn[];

    constructor($scope: ng.IScope) {

        this.$scope = <IUibModalScope>$scope.$parent;

        const optionsScope = this.$scope.$parent;

        this.columns = optionsScope["columns"]
        this.analysisColumns = optionsScope["analysisColumns"] || []

    }

    get title(): string {
        return "Displayed columns (" + this.visibleColumns + "/10)";
    }

    get visibleColumns(): number {
        return this.columns.filter(c => c.visible).length + this.analysisColumns.filter(c => c.visible).length;
    }

    canCheckOthers(): boolean {
        return this.visibleColumns < 10;
    }

    unselectAll() {
        if (this.columns) {
            this.columns.forEach(c => c.visible = false);
        }
        if (this.analysisColumns) {
            this.analysisColumns.forEach(c => c.visible = false);
        }
    }

    close() {
        this.$scope.$close();
    }
}
